const STORAGE_KEY = 'dm-theme';
const VALID_THEMES = new Set(['light', 'dark']);

export const getTheme = () => document.documentElement.dataset.theme || 'light';

export const toggleTheme = () => {
  const next = getTheme() === 'dark' ? 'light' : 'dark';
  document.documentElement.dataset.theme = next;
  window.dispatchEvent(new CustomEvent('dm-theme-change', { detail: next }));
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* private mode: theme still applies for this visit */
  }
  return next;
};
